/* global axios */
import ApiClient from './ApiClient';

class CrmPipelineAPI {
  constructor() {
    this.stages = new ApiClient('crm/pipeline_stages', {
      accountScoped: true,
    });
    this.deals = new ApiClient('crm/deals', {
      accountScoped: true,
    });
    this.dealFields = new ApiClient('crm/deal_fields', {
      accountScoped: true,
    });
    this.marketingDashboard = new ApiClient('crm/marketing_dashboard', {
      accountScoped: true,
    });
  }

  getStages() {
    return this.stages.get();
  }

  exportDeals(params = {}) {
    return axios.get(`${this.deals.url}/export.csv`, {
      params,
      responseType: 'blob',
    });
  }

  getDeals(params = {}) {
    return axios.get(this.deals.url, { params });
  }

  getMarketingDashboardConfig() {
    return this.marketingDashboard.get();
  }

  getMarketingSpend(params = {}) {
    return axios.get(`${this.marketingDashboard.url}/spend`, { params });
  }

  getMarketingMonthlySpend(params = {}) {
    return axios.get(`${this.marketingDashboard.url}/monthly_spend`, { params });
  }

  getManualSpendEntries() {
    return axios.get(`${this.marketingDashboard.url}/manual_spend_entries`);
  }

  createManualSpendEntry(data) {
    return axios.post(`${this.marketingDashboard.url}/manual_spend_entries`, data);
  }

  updateManualSpendEntry(id, data) {
    return axios.patch(`${this.marketingDashboard.url}/manual_spend_entries/${id}`, data);
  }

  updateMarketingDashboardConfig(data) {
    return axios.patch(this.marketingDashboard.url, data);
  }

  getDeal(id) {
    return this.deals.show(id);
  }

  createDeal(data) {
    return this.deals.create(data);
  }

  updateDeal(id, data) {
    return this.deals.update(id, data);
  }

  conversationUrl(conversationDisplayId) {
    return `${this.deals.baseUrl()}/conversations/${conversationDisplayId}`;
  }

  getConversation(conversationDisplayId) {
    return axios.get(this.conversationUrl(conversationDisplayId));
  }

  getConversationMessages(conversationDisplayId, params = {}) {
    return axios.get(`${this.conversationUrl(conversationDisplayId)}/messages`, {
      params,
    });
  }

  sendConversationMessage(conversationDisplayId, data) {
    return axios.post(`${this.conversationUrl(conversationDisplayId)}/messages`, data);
  }

  getDealFields() {
    return this.dealFields.get();
  }

  createDealField(data) {
    return this.dealFields.create(data);
  }

  updateDealField(id, data) {
    return this.dealFields.update(id, data);
  }

  deleteDealField(id) {
    return this.dealFields.delete(id);
  }

  updateStageRequiredFields(data) {
    return axios.patch(`${this.dealFields.url}/stage_requirements`, data);
  }
}

export default new CrmPipelineAPI();
